// ブランドストーリー（MainContent.js から共通化 — 2D/3D 両方で使う）
const stories = [
  {
    id: 'origin',
    en: 'Origin',
    title: 'グアテマラという選択',
    text: 'さまざまな産地の豆と向き合う中で、最も深く惹かれたのがグアテマラでした。深いコクと芳醇な香り——いつかこの豆を育てる農園と直接つながり、一杯の向こう側にいる人の顔が見える関係を築いていきたい。それがGURI COFFEEの夢です。',
    img: '/images/generated/story_origin.jpg',
  },
  {
    id: 'roasting',
    en: 'Roasting',
    title: '焙煎という向き合い方',
    text: '溶接工として「素材と向き合う」ことを日々の仕事で学んだ。焙煎もおなじ。豆の声を聞きながら、その日の最良を引き出す。職人気質が、コーヒーの世界にも生きています。',
    img: '/images/generated/story_roasting.jpg',
  },
  {
    id: 'philosophy',
    en: 'Philosophy',
    title: '那谷寺と余白の精神',
    text: '石川・那谷寺の深い静けさが、GURI COFFEEの世界観の核にあります。急ぎすぎる時代に、立ち止まる場所を。コーヒーが、あなたの余白時間を守る存在でありたい。',
    img: '/images/generated/story_philosophy.jpg',
  },
];

export default stories;
